import styled from 'styled-components';

export const BookingDetailWrap = styled.section`
  background: white;
  border-radius: 0.4rem;
`;
export const BusDetail = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2em;
`;
export const SeatDetail = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top: 1px solid #eef4fd;
  padding: 0.8rem 2em;
`;

export const BusName = styled.div(
  props => `
    font-size: 2.2rem;
    font-weight: bold;
    color: black;
    font-family:${props.theme.font.fontFamily};
    padding-bottom: 0.5rem;
    display: flex;
    flex-direction: row;
`,
);
export const SmallTxt = styled.p`
  font-size: 1.2rem;
  color: #777777;
  padding-right: 1rem;
`;
export const PopupLink = styled.p`
  font-size: 1.2rem;
  color: #2276e3;
  cursor:pointer;
`;
export const SeatNumber = styled.span(
  props => `
    font-family:${props.theme.font.fontFamily};
    font-size: 1.4rem;
    font-weight: bold;
    color: black;
    margin: 0 0.5rem;

`,
);

export const DropingPointWraper = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 1.5rem;
`;

export const GoSafeTag = styled.div`

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0.5rem;
    margin-left: 1rem;
    background: #e9f6ea;
    span{
        color: #777;
        font-size: 1.2rem;
        padding-left: 0.5rem;
    }
`
